<app-loading *ngIf="isLoading"></app-loading>

<div class="filter-container" *ngIf="!isLanding">
  <div class="filter-fields-wrapper">
    <div class="filter-input-fields">
    <div *ngIf="showSystemFilter" class="mat-form-group">
      <mat-form-field class="mat-form-input-field input-field-wide">
        <mat-label class="mat-form-group-label">System</mat-label>
        <mat-select [formControl]="SystemSelected" multiple [title]="getTitleString(SystemSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{getSelectedString(SystemSelected, 'System')}}
          </mat-select-trigger>
          <mat-option #allSystemSelected [value]="allOptionText"
            (click)="allSelectedHandler(SystemSelected,SystemData,allSystemSelected,'System')">{{allOptionText}}
          </mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of SystemData" [value]="data.name" [title]="data.name"
            (click)="singleFilterItemSelectedHandler(SystemData,SystemSelected,allSystemSelected,'System')">
            {{data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group">
      <mat-form-field class="mat-form-input-field input-field-wide">
        <mat-label class="mat-form-group-label">Organization</mat-label>
        <mat-select [formControl]="OrgSelected" multiple [title]="getTitleString(OrgSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{getSelectedString(OrgSelected, 'Organization')}}
          </mat-select-trigger>
          <mat-option #allOrgSelected [value]="allOptionText"
            (click)="allSelectedHandler(OrgSelected,OrganizationData,allOrgSelected,'Organization')">{{allOptionText}}
          </mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of OrganizationData" [value]="data.name" [title]="data.name"
            (click)="singleFilterItemSelectedHandler(OrganizationData,OrgSelected,allOrgSelected,'Organization')">
            {{data.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group" style="width: 150px;">
      <mat-form-field class="mat-form-input-field input-field-medium">
        <mat-label class="mat-form-group-label">Year</mat-label>
        <mat-select [formControl]="YearSelected" multiple [title]="getTitleString(YearSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{YearSelected.value ? YearSelected.value[0] : ''}}
            <span *ngIf="YearSelected.value?.length > 1" class="example-additional-selection">
              <!-- (+{{YearSelected.value.length - 1}} {{YearSelected.value?.length === 2 ? 'other' : 'others'}}) -->
              {{getSelectedString(YearSelected)}}
            </span>
          </mat-select-trigger>
          <mat-option #allYearSelected [value]="allOptionText"
            (click)="allSelectedHandler(YearSelected,YearData,allYearSelected,'Year')">{{allOptionText}}</mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of YearData" [value]="data.name"
            (click)="singleFilterItemSelectedHandler(YearData,YearSelected,allYearSelected,'Year')">{{data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group" style="width: 180px;">
      <mat-form-field class="mat-form-input-field input-field-medium">
        <mat-label class="mat-form-group-label">Cohort</mat-label>
        <mat-select [formControl]="CohortSelected" multiple [title]="getTitleString(CohortSelected.value)">
          <mat-select-trigger class="mat-form-trigger-label">
            {{CohortSelected.value ? CohortSelected.value[0] : ''}}
            <span *ngIf="CohortSelected.value?.length > 1" class="example-additional-selection">
              <!-- (+{{CohortSelected.value.length - 1}} {{CohortSelected.value?.length === 2 ? 'other' : 'others'}}) -->
              {{getSelectedString(CohortSelected)}}
            </span>
          </mat-select-trigger>
          <mat-option #allCohortSelected [value]="allOptionText"
            (click)="allSelectedHandler(CohortSelected,CohortData,allCohortSelected,'Cohort')">
            {{allOptionText}}</mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let data of CohortData" [value]="data.name"
            (click)="singleFilterItemSelectedHandler(CohortData,CohortSelected,allCohortSelected,'Cohort')">
            {{data.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-form-group-button">
      <button mat-stroked-button color="primary" class="right-button filter-button"
        (click)="showAdvancedFilters = !showAdvancedFilters">
        More Filters
      </button>
    </div>
    <div class="mat-form-group-button">
      <button *ngIf="!isLanding" mat-raised-button color="primary" class="right-button marLeft5" (click)="onSubmit()"
        [disabled]="CohortSelected.disabled">Go
      </button>
    </div>
    <div class="filter-list-icon-container">
      <button mat-icon-button
        (click)="showorHideAdvancedFilterSelections($event)" matTooltip="Click to view selected filters">
        <mat-icon class="filter-list-icon">filter_list</mat-icon>
      </button>
    </div>
  </div><!-- end filter-input-fields -->

  <div class="export-button-row" *ngIf="exportEnabled">
    <button mat-stroked-button color="primary" class="export-report-button" (click)="openExportPopup()">
      <mat-icon>ios_share</mat-icon>
      Export
    </button>
    <!-- <button mat-stroked-button color="primary" class="export-report-button export-dashboard-button" (click)="goToReportsDashboard()">
      <mat-icon>dashboard</mat-icon>
      Export Dashboard
    </button> -->
    <!-- <button mat-icon-button class="download-panel-btn" (click)="toggleDownloadPanel()" matTooltip="View recent exports">
      <mat-icon>download</mat-icon>
    </button> -->
  </div>

    <!-- Download Panel -->
    <div class="download-panel" *ngIf="showDownloadPanel">
      <div class="download-panel-header">
        <span class="download-panel-title">
          <mat-icon class="download-panel-title-icon">download</mat-icon>
          Recent Exports
        </span>
        <span class="download-panel-header-actions">
          <button mat-icon-button class="download-panel-collapse" (click)="toggleMinimizeDownloadPanel()"
            [matTooltip]="downloadPanelMinimized ? 'Expand' : 'Minimize'">
            <mat-icon>{{ downloadPanelMinimized ? 'open_in_full' : 'close_fullscreen' }}</mat-icon>
          </button>
          <button mat-icon-button class="download-panel-close" (click)="closeDownloadPanel()" matTooltip="Close">
            <mat-icon>close</mat-icon>
          </button>
        </span>
      </div>

      <div class="download-panel-body" *ngIf="!downloadPanelMinimized">
        <div *ngIf="exportJobsLoading" class="download-panel-loading">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <div *ngIf="!exportJobsLoading && visibleJobs().length === 0" class="download-panel-empty">
          No reports available to download.
        </div>

        <div class="download-job-row" *ngFor="let job of visibleJobs()">
          <div class="download-job-info">
            <span class="download-job-name" [matTooltip]="job.fileName">{{ job.fileName }}</span>
            <span class="download-job-status"
              [class.status-success]="isJobCompleted(job)"
              [class.status-failed]="job.status === 'Failed'"
              [class.status-cancelled]="job.status === 'Cancelled'"
              [class.status-processing]="job.status === 'Processing'">
              {{ jobStatusLabel(job) }}
            </span>
            <div class="download-job-progress">
              <div *ngIf="isJobCompleted(job)" class="download-job-progress-bar progress-complete"></div>
              <div *ngIf="job.status === 'Failed'" class="download-job-progress-bar progress-failed"></div>
              <div *ngIf="job.status === 'Cancelled'" class="download-job-progress-bar progress-cancelled"></div>
              <mat-progress-bar *ngIf="job.status === 'Pending' || job.status === 'Processing'" mode="indeterminate" class="progress-indeterminate"></mat-progress-bar>
            </div>
          </div>

          <div class="download-job-actions">
            <mat-icon class="job-check-icon" *ngIf="isJobCompleted(job)">check</mat-icon>
            <mat-icon class="job-check-icon job-check-placeholder" *ngIf="job.status === 'Failed'"></mat-icon>
            <mat-icon class="job-check-icon job-check-placeholder" *ngIf="job.status === 'Pending'"></mat-icon>
            <mat-icon class="job-check-icon job-check-placeholder" *ngIf="job.status === 'Cancelled'"></mat-icon>
            <mat-icon class="job-check-icon job-check-placeholder" *ngIf="job.status === 'Processing'"></mat-icon>

            <button class="job-download-btn"
              [class.job-download-btn-active]="isJobCompleted(job)"
              [disabled]="!isJobCompleted(job)"
              (click)="downloadJobFile(job)"
              matTooltip="{{ isJobCompleted(job) ? 'Download' : '' }}">
              <mat-icon>download</mat-icon>
            </button>

            <span style="display:inline-flex;"
              [matTooltip]="job.status === 'Processing' ? 'Export is in processing. Cannot cancel the export at this time' : job.status === 'Pending' ? 'Cancel Export' : 'Remove'">
              <button mat-icon-button class="job-dismiss-btn"
                [disabled]="job.status === 'Processing'"
                (click)="dismissJob(job)">
                <mat-icon>close</mat-icon>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showAdvancedFilters">
  <div class="screen-overlay"></div>
  <div class="overlay-container">

    <div class="selected-list-title">
      <span style="display: flex;align-items: left;">
        <mat-icon>tune</mat-icon>
        <span style="padding-left: 10px;">Filter Settings</span>
      </span>
      <span>
        <mat-icon (click)="closePopup()">close</mat-icon>
      </span>
    </div>

    <div class="selected-list">
      <div id="compareGroupFilter">
        <div class="comparegrouptype-wrapper">
          <label class="comparegrouptype-radio-group-label">Compare Group Type</label>
          <mat-radio-group aria-labelledby="comparegrouptype-radio-group-label" class="comparegrouptype-radio-group"
            [(ngModel)]="compareGroupType" (change)="compareGroupTypeOnChange($event)">
            <mat-radio-button [value]="customCompareGroupLabelText" checked
              class="comparegrouptype-radio-button">{{customCompareGroupLabelText}}</mat-radio-button>&nbsp;&nbsp;
            <mat-radio-button [value]="selfCompareGroupLabelText"
              class="comparegrouptype-radio-button">{{selfCompareGroupLabelText}}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="filterRow">
          <mat-form-field class="mat-form-input-field input-field-wide">
            <mat-label class="mat-form-group-label">Benchmark</mat-label>
            <mat-select [formControl]="CompareGroupSelected" (selectionChange)="compareGroupOnChange($event)">
              <mat-select-trigger class="mat-form-trigger-label">
                {{CompareGroupSelected.value ? CompareGroupSelected.value : ''}}
              </mat-select-trigger>
              <mat-option *ngFor="let data of CompareGroupData" [title]="data.name" [value]="data.name"
                style="font-size: 12px;color: #696969;">
                {{data.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- <div>
        <span class="subHeader">Dimensions</span>
      </div> -->
      <div class="filterRow">

        <div class="filterlist" id="ageFilter">
          <span class="filter-header">Age</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #AgeControl [formControl]="AgeSelected" class="list-horizontal">
            <!-- [style.overflow]="'auto'" [style.height.px]="'150'" -->
            <mat-list-option #allAgeSelected (click)="allDimSelectedHandler(AgeSelected,AgeData,allAgeSelected,'Age')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of AgeData" [value]="data.name" [title]="data.name"
              checkboxPosition="before" (click)="singleDimFilterItemSelectedHandler(allAgeSelected,'Age')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="employmentStatusFilter">
          <span class="filter-header">Employment Status</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #EmploymentStatusControl [formControl]="EmploymentStatusSelected" class="list-horizontal">
            <mat-list-option #allEmploymentStatusSelected
              (click)="allDimSelectedHandler(EmploymentStatusSelected,EmploymentStatusData,allEmploymentStatusSelected,'EmploymentStatus')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of EmploymentStatusData" [value]="data.name" [title]="data.name"
              checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allEmploymentStatusSelected,'EmploymentStatus')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="ethnicityFilter">
          <span class="filter-header">Ethnicity</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #EthnicityControl [formControl]="EthnicitySelected" class="list-horizontal">
            <mat-list-option #allEthnicitySelected
              (click)="allDimSelectedHandler(EthnicitySelected,EthnicityData,allEthnicitySelected,'Ethnicity')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of EthnicityData" [value]="data.name" [title]="data.name"
              checkboxPosition="before" (click)="singleDimFilterItemSelectedHandler(allEthnicitySelected,'Ethnicity')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="genderFilter">
          <span class="filter-header">Gender</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #GenderControl [formControl]="GenderSelected" class="list-horizontal">
            <mat-list-option #allGenderSelected
              (click)="allDimSelectedHandler(GenderSelected,GenderData,allGenderSelected,'Gender')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of GenderData" [value]="data.name" [title]="data.name"
              checkboxPosition="before" (click)="singleDimFilterItemSelectedHandler(allGenderSelected,'Gender')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>
      <div class="filterRow">

        <div class="filterlist" id="gpaFilter">
          <span class="filter-header">GPA</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #GPAControl [formControl]="GPASelected" class="list-horizontal">
            <mat-list-option #allGPASelected (click)="allDimSelectedHandler(GPASelected,GPAData,allGPASelected,'GPA')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of GPAData" [value]="data.name" [title]="data.name"
              checkboxPosition="before" (click)="singleDimFilterItemSelectedHandler(allGPASelected,'GPA')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="degreeAwardedFilter">
          <span class="filter-header">Nursing Degree Received</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #DegreeAwardedControl [formControl]="DegreeAwardedSelected" class="list-horizontal">
            <!-- [(ngModel)]="selectedValue" -->
            <mat-list-option #allDegreeAwardedSelected
              (click)="allDimSelectedHandler(DegreeAwardedSelected,DegreeAwardedData,allDegreeAwardedSelected,'DegreeAwarded')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <!-- (click)="toggleAllSelection(degOption,'DegreeAwarded') "  -->
            <mat-list-option *ngFor="let data of DegreeAwardedData" [value]="data.name" [title]="data.name"
              checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allDegreeAwardedSelected,'DegreeAwarded')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="previousDegreeFilter">
          <span class="filter-header">Previous Degree</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #PreviousDegreeControl [formControl]="PreviousDegreeSelected" class="list-horizontal">
            <mat-list-option #allPreviousDegreeSelected
              (click)="allDimSelectedHandler(PreviousDegreeSelected,PreviousDegreeData,allPreviousDegreeSelected,'PreviousDegree')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of PreviousDegreeData" [value]="data.name" [title]="data.name"
              checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allPreviousDegreeSelected,'PreviousDegree')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" *ngIf="isTerminationReport" id="terminationReasonFilter">
          <span class="filter-header">Termination Reason</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #TerminationReasonControl [formControl]="TerminationReasonSelected"
            class="list-horizontal">
            <mat-list-option #allTerminationReasonSelected
              (click)="allDimSelectedHandler(TerminationReasonSelected,TerminationReasonData,allTerminationReasonSelected,'TerminationReason')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of TerminationReasonData" [value]="data.name" [title]="data.name"
              checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allTerminationReasonSelected,'TerminationReason')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="previousHealthCareExperienceFilter">
          <span class="filter-header">Previous Health Care Experience</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #PreviousHealthCareExperienceControl [formControl]="PreviousHealthCareExperienceSelected"
            class="list-horizontal">
            <mat-list-option #allPreviousHealthCareExperienceSelected
              (click)="allDimSelectedHandler(PreviousHealthCareExperienceSelected,PreviousHealthCareExperienceData,allPreviousHealthCareExperienceSelected,'PreviousHealthCareExperience')"
              [value]="allOptionText" [title]="allOptionText" checkboxPosition="before"
              class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of PreviousHealthCareExperienceData" [value]="data.name"
              [title]="data.name" checkboxPosition="before"
              (click)="singleDimFilterItemSelectedHandler(allPreviousHealthCareExperienceSelected,'PreviousHealthCareExperience')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
        <div class="filterlist" id="unitFilter">
          <span class="filter-header">Unit</span>
          <div class="dimensions-header-line">
            <mat-divider></mat-divider>
          </div>
          <mat-selection-list #UnitControl [formControl]="UnitSelected" class="list-horizontal">
            <mat-list-option #allUnitSelected
              (click)="allDimSelectedHandler(UnitSelected,UnitData,allUnitSelected,'Unit')" [value]="allOptionText"
              [title]="allOptionText" checkboxPosition="before" class="list-option">{{allOptionText}}</mat-list-option>
            <mat-list-option *ngFor="let data of UnitData" [value]="data.name" [title]="data.name"
              checkboxPosition="before" (click)="singleDimFilterItemSelectedHandler(allUnitSelected,'Unit')"
              class="list-option">
              {{data.name}}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>

    </div>

    <!-- </ng-template> -->
    <div class="selected-list-footer">
      <div>
        <button mat-raised-button color="primary" class="selected-list-button" (click)="saveMoreFilters()">{{ isLanding?
          "Save Filters" : "Go" }}</button>
      </div>
      <span style="padding-left: 16px;">
        <button mat-stroked-button color="primary" class="selected-list-button" (click)="resetFilters()">Reset
          Filters</button>
      </span>
    </div>
  </div>
</div>
<div *ngIf="showAdvancedFilterSelections && !showAdvancedFilters && !isApplyFiltersInProgress">
  <!-- <div class="screen-overlay"></div> -->
  <div class="filter-list-selection-container" [style]="{top: popupY + 'px !important', left: popupX + 'px !important'}">
    <div class="filter-list-card-container">
      <div class="filter-card">
        <mat-card appearance="raised"
          class="card-style filter-selected" matTooltip="{{CompareGroupSelected.value}}" (click)="showAdvancedFiltersPopup('compareGroupFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Compare Group: {{CompareGroupSelected.value}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(AgeSelected.value)" matTooltip="{{getMatCardText(AgeSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('ageFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Age: {{getMatCardText(AgeSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(EmploymentStatusSelected.value)" matTooltip="{{getMatCardText(EmploymentStatusSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('employmentStatusFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Employment Status: {{getMatCardText(EmploymentStatusSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(EthnicitySelected.value)" matTooltip="{{getMatCardText(EthnicitySelected.value, 0)}}" (click)="showAdvancedFiltersPopup('ethnicityFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Ethnicity: {{getMatCardText(EthnicitySelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(GenderSelected.value)" matTooltip="{{getMatCardText(GenderSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('genderFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Gender: {{getMatCardText(GenderSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(GPASelected.value)" matTooltip="{{getMatCardText(GPASelected.value, 0)}}" (click)="showAdvancedFiltersPopup('gpaFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">GPA: {{getMatCardText(GPASelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(DegreeAwardedSelected.value)" matTooltip="{{getMatCardText(DegreeAwardedSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('degreeAwardedFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Nursing Degree Received: {{getMatCardText(DegreeAwardedSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(PreviousDegreeSelected.value)" matTooltip="{{getMatCardText(PreviousDegreeSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('previousDegreeFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Previous Degree: {{getMatCardText(PreviousDegreeSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card" *ngIf="!isCF2006Reports">
        <mat-card appearance="raised"
          [class]="findCardStyle(PreviousHealthCareExperienceSelected.value)" matTooltip="{{getMatCardText(PreviousHealthCareExperienceSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('previousHealthCareExperienceFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Previous Health Care Experience: {{getMatCardText(PreviousHealthCareExperienceSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card" *ngIf="isTerminationReport">
        <mat-card appearance="raised"
          [class]="findCardStyle(TerminationReasonSelected.value)" matTooltip="{{getMatCardText(TerminationReasonSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('terminationReasonFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Termination Reason: {{getMatCardText(TerminationReasonSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised"
          [class]="findCardStyle(UnitSelected.value)" matTooltip="{{getMatCardText(UnitSelected.value, 0)}}" (click)="showAdvancedFiltersPopup('unitFilter')">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Unit: {{getMatCardText(UnitSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div style="padding-right: 5px;padding-top: 5px;">
      <span>
        <mat-icon (click)="showorHideAdvancedFilterSelections()" style="padding-right: 5px;padding-top: 5px;cursor: pointer;" matTooltip="Close">close</mat-icon>
      </span>
    </div>
  </div>
</div>
<div *ngIf="isApplyFiltersInProgress">
  <div class="screen-overlay"></div>
  <div class="overlay-container-loading">
    <div class="selected-list-title">
      <mat-progress-spinner color="accent" mode="indeterminate" value="50" diameter="40">
      </mat-progress-spinner>
      <span class="marLeft5">
        Loading, please wait..
      </span>
    </div>
  </div>
</div>
<div *ngIf="isLanding && !isApplyFiltersInProgress" class="landing-container">

  <div>
    <div class="welcomeText">Welcome {{loggedInUserName}}</div>
    <div class="stepContainer">
      <img src="../../../assets/public/images/exclamation.png" alt="Step 1" style="width: 20px;height: 20px;">
      Please follow these steps to customize the data displayed on the NRP data dashboard.
    </div>
    <div>
      <div class="all-steps-text-container">
        <div class="stepContainer">
          <div>
            <!-- <div>
              <img src="../../../assets/public/images/step1.png" alt="Step 1" class="stepImage">
            </div> -->
            <div class="circle">
              1
            </div>
            <div class="stepText">Step 1</div>
          </div>
          <div class="step1Description">
            <!-- If pageTitle is CaseyFinkExperience2023 then below otherwise display pageTitle-->
            <div>
              <span class="fontBold">
                {{reportName.toLocaleLowerCase().indexOf('caseyfinkexperience2023') > -1 ? `${this.pageTitle} is the default report.` : this.pageTitle}}
              </span>
              <div class="newRow">
                To change the survey, please select from Surveys menu on page header.
              </div>
            </div>
          </div>
        </div>
        <div class="stepContainer step2style">
          <div>
            <!-- <div>
              <img src="../../../assets/public/images/step2.png" alt="Step 2" class="stepImage">
            </div> -->
            <div class="circle">
              2
            </div>
            <div class="stepText">Step 2</div>
          </div>
          <div class="step2Description">
            Choose the System, Organization, Year and Cohort as applicable.
          </div>
          <div class="step2FilterContainer">
            <div class="filter-input-fields" style="justify-content: flex-start">
              <div *ngIf="showSystemFilter" class="mat-form-group">
                <mat-form-field class="mat-form-input-field input-field-wide-landing">
                  <mat-label class="mat-form-group-label">System</mat-label>
                  <mat-select [formControl]="SystemSelected" multiple [title]="getTitleString(SystemSelected.value)">
                    <mat-select-trigger class="mat-form-trigger-label">
                      {{getSelectedString(SystemSelected, 'System')}}
                    </mat-select-trigger>
                    <mat-option #allSystemSelected [value]="allOptionText"
                      (click)="allSelectedHandler(SystemSelected,SystemData,allSystemSelected,'System')">{{allOptionText}}
                    </mat-option>
                    <mat-divider></mat-divider>
                    <mat-option *ngFor="let data of SystemData" [value]="data.name" [title]="data.name"
                      (click)="singleFilterItemSelectedHandler(SystemData,SystemSelected,allSystemSelected,'System')">
                      {{data.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="mat-form-group">
                <mat-form-field class="mat-form-input-field input-field-wide-landing">
                  <mat-label class="mat-form-group-label">Organization</mat-label>
                  <mat-select [formControl]="OrgSelected" multiple [title]="getTitleString(OrgSelected.value)">
                    <mat-select-trigger class="mat-form-trigger-label">
                      {{getSelectedString(OrgSelected, 'Organization')}}
                    </mat-select-trigger>
                    <mat-option #allOrgSelected [value]="allOptionText"
                      (click)="allSelectedHandler(OrgSelected,OrganizationData,allOrgSelected,'Organization')">{{allOptionText}}
                    </mat-option>
                    <mat-divider></mat-divider>
                    <mat-option *ngFor="let data of OrganizationData" [value]="data.name" [title]="data.name"
                      (click)="singleFilterItemSelectedHandler(OrganizationData,OrgSelected,allOrgSelected,'Organization')">
                      {{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="mat-form-group">
                <mat-form-field class="mat-form-input-field input-field-medium-landing">
                  <mat-label class="mat-form-group-label">Year</mat-label>
                  <mat-select [formControl]="YearSelected" multiple [title]="getTitleString(YearSelected.value)">
                    <mat-select-trigger class="mat-form-trigger-label">
                      {{YearSelected.value ? YearSelected.value[0] : ''}}
                      <span *ngIf="YearSelected.value?.length > 1" class="example-additional-selection">
                        <!-- (+{{YearSelected.value.length - 1}} {{YearSelected.value?.length === 2 ? 'other' : 'others'}}) -->
                        {{getSelectedString(YearSelected)}}
                      </span>
                    </mat-select-trigger>
                    <mat-option #allYearSelected [value]="allOptionText"
                      (click)="allSelectedHandler(YearSelected,YearData,allYearSelected,'Year')">{{allOptionText}}</mat-option>
                    <mat-divider></mat-divider>
                    <mat-option *ngFor="let data of YearData" [value]="data.name"
                      (click)="singleFilterItemSelectedHandler(YearData,YearSelected,allYearSelected,'Year')">{{data.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="mat-form-group">
                <mat-form-field class="mat-form-input-field input-field-medium-landing">
                  <mat-label class="mat-form-group-label">Cohort</mat-label>
                  <mat-select [formControl]="CohortSelected" multiple [title]="getTitleString(CohortSelected.value)">
                    <mat-select-trigger class="mat-form-trigger-label">
                      {{CohortSelected.value ? CohortSelected.value[0] : ''}}
                      <span *ngIf="CohortSelected.value?.length > 1" class="example-additional-selection">
                        <!-- (+{{CohortSelected.value.length - 1}} {{CohortSelected.value?.length === 2 ? 'other' : 'others'}}) -->
                        {{getSelectedString(CohortSelected)}}
                      </span>
                    </mat-select-trigger>
                    <mat-option #allCohortSelected [value]="allOptionText"
                      (click)="allSelectedHandler(CohortSelected,CohortData,allCohortSelected,'Cohort')">
                      {{allOptionText}}</mat-option>
                    <mat-divider></mat-divider>
                    <mat-option *ngFor="let data of CohortData" [value]="data.name"
                      (click)="singleFilterItemSelectedHandler(CohortData,CohortSelected,allCohortSelected,'Cohort')">
                      {{data.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="stepContainer step3style">
          <div>
            <!-- <div>
              <img src="../../../assets/public/images/step3.png" alt="Step 3" class="stepImage">
            </div> -->
            <div class="circle">
              3
            </div>
            <div class="stepText">Step 3</div>
          </div>
          <div class="step2Description">
            Select the benchmark and demographic filters
          </div>
          <div class="step3FilterContainer">
            <div>
              <button mat-stroked-button color="primary" class="right-button filter-button"
                (click)="showAdvancedFilters = !showAdvancedFilters">
                <mat-icon>check_circle</mat-icon>
                Select benchmark/filters
              </button>
            </div>
            <div>
              <button mat-icon-button
                (click)="showorHideAdvancedFilterSelections($event, 400)" style="padding-top: 0px !important;" matTooltip="Click to view selected filters">
                <mat-icon class="filter-list-icon-landing">filter_list</mat-icon>
              </button>
            </div>
          </div>
          <!-- <div class="filter-list-icon-container" (mouseenter)="showorHideAdvancedFilterSelections()">
            <button mat-icon-button
              (click)="showAdvancedFilterSelections = !showAdvancedFilterSelections">
              <mat-icon class="filter-list-icon">filter_list</mat-icon>
            </button>
          </div> -->
        </div>
        <div class="stepContainer step4style">
          <div>
            <!-- <div>
              <img src="../../../assets/public/images/step3.png" alt="Step 3" class="stepImage">
            </div> -->
            <div class="circle">
              4
            </div>
            <div class="stepText">Step 4</div>
          </div>
          <div class="step2Description">
            Click on the "Go" button to populate the dashboard
          </div>
          <div class="step2FilterContainer" style="padding-top: 20px;">
            <button mat-raised-button color="primary" (click)="LoadReport()" class="go-button">
              <mat-icon>search</mat-icon>
              GO
            </button>
          </div>
        </div>
      </div>
      <div class="landingPageImageContainer">
        <img src="../../../assets/public/images/landingimage_2.svg" alt="Landing page">
      </div>
    </div>
    <!-- <div class="divider-line">
      <mat-divider></mat-divider>
    </div>
    <div class="stepContainer" style="text-align: center;">
      <div>
        Click on the "Go" button to populate the dashboard
      </div>
      <div style="padding-top:15px;">
        <button mat-raised-button color="primary" (click)="LoadReport()" class="go-button">
          <mat-icon>search</mat-icon>
          GO
        </button>
      </div>
    </div> -->
  </div>


</div>
<div *ngIf="showExportPopup">
  <div class="screen-overlay"></div>
  <div class="export-popup-container">
    <div class="export-popup-header">
      <span class="export-popup-title">Export Details</span>
      <button mat-icon-button class="export-popup-close" (click)="cancelExport()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="export-filters-header">Filters Added to this Report</div>
    <div class="filter-list-card-container">
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(SystemSelected.value)" matTooltip="{{getMatCardText(SystemSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">System: {{getMatCardText(SystemSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(OrgSelected.value)" matTooltip="{{getMatCardText(OrgSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Organization: {{getMatCardText(OrgSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(YearSelected.value)" matTooltip="{{getMatCardText(YearSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Year: {{getMatCardText(YearSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(CohortSelected.value)" matTooltip="{{getMatCardText(CohortSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Cohort: {{getMatCardText(CohortSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" class="card-style filter-selected" matTooltip="{{CompareGroupSelected.value}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Compare Group: {{CompareGroupSelected.value}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(AgeSelected.value)" matTooltip="{{getMatCardText(AgeSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Age: {{getMatCardText(AgeSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(EmploymentStatusSelected.value)" matTooltip="{{getMatCardText(EmploymentStatusSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Employment Status: {{getMatCardText(EmploymentStatusSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(EthnicitySelected.value)" matTooltip="{{getMatCardText(EthnicitySelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Ethnicity: {{getMatCardText(EthnicitySelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(GenderSelected.value)" matTooltip="{{getMatCardText(GenderSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Gender: {{getMatCardText(GenderSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(GPASelected.value)" matTooltip="{{getMatCardText(GPASelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">GPA: {{getMatCardText(GPASelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(DegreeAwardedSelected.value)" matTooltip="{{getMatCardText(DegreeAwardedSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Nursing Degree Received: {{getMatCardText(DegreeAwardedSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(PreviousDegreeSelected.value)" matTooltip="{{getMatCardText(PreviousDegreeSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Previous Degree: {{getMatCardText(PreviousDegreeSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card" *ngIf="!isCF2006Reports">
        <mat-card appearance="raised" [class]="findCardStyle(PreviousHealthCareExperienceSelected.value)" matTooltip="{{getMatCardText(PreviousHealthCareExperienceSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Previous Health Care Experience: {{getMatCardText(PreviousHealthCareExperienceSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="filter-card">
        <mat-card appearance="raised" [class]="findCardStyle(UnitSelected.value)" matTooltip="{{getMatCardText(UnitSelected.value, 0)}}">
          <mat-card-content>
            <span class="filter-card-text-container">
              <mat-icon class="filter-card-check-icon">check</mat-icon>
              <span class="filter-card-text">Unit: {{getMatCardText(UnitSelected.value)}}</span>
            </span>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="export-popup-name-row">
      <p *ngIf="exportReportNameError" class="export-name-error">* Report name is required</p>
      <fieldset class="export-name-fieldset">
        <legend class="export-name-legend">Name your report (Required)</legend>
        <input class="export-name-input" placeholder="Enter a name" [(ngModel)]="exportReportName" (input)="exportReportNameError = false" maxlength="255" />
      </fieldset>
    </div>
    <div class="export-popup-actions">
      <button type="button" mat-raised-button color="primary" class="export-action-button" (click)="startExport(); $event.stopPropagation()">Start</button>
      <button mat-stroked-button color="primary" class="export-action-button" (click)="cancelExport()">Cancel</button>
    </div>
  </div>
</div>
<div id="embedReport" class="report-frame-withfilters" *ngIf="!isLanding"></div>